import { createRoot } from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { AuthProvider } from '@/services/auth/AuthContext';
import { persistor } from '@/store/persistor';
import { store } from '@/store/store';
import AppWeb from '@/AppWeb';

createRoot(document.getElementById('root')!).render(
    <AuthProvider>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <AppWeb />
            </PersistGate>
        </Provider>
    </AuthProvider>
);
